import { render, staticRenderFns } from "./MealForm.vue?vue&type=template&id=6e6aa340&"
import script from "./MealForm.vue?vue&type=script&lang=js&"
export * from "./MealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports